// extracted by css-extract-rspack-plugin
export default {"workerCard__button":"workerCard__button-mSny41","workerCardButton":"workerCard__button-mSny41"};